'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () {
                        return e[k];
                    }
                });
            }
        });
    }
    n['default'] = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

const Svg12 = (props) => (React__namespace.createElement("svg", Object.assign({ width: 12, height: 13, viewBox: "0 0 12 13", fill: "none" }, props),
    React__namespace.createElement("path", { d: "M3.31392 5.52067C3.03127 5.2569 3.01597 4.81395 3.27974 4.53131L5.32199 2.3429C5.69322 1.94511 6.32377 1.9451 6.695 2.3429L8.71974 4.51249C8.98351 4.79513 8.96821 5.23808 8.68557 5.50185C8.40293 5.76561 7.95998 5.75032 7.69621 5.46768L6.69836 4.39843L6.69835 7.90514C6.69835 8.29174 6.38495 8.60514 5.99835 8.60514C5.61176 8.60514 5.29835 8.29174 5.29835 7.90514L5.29836 4.4202L4.30328 5.48649C4.03951 5.76913 3.59656 5.78443 3.31392 5.52067Z", fill: props.fillColor, fillOpacity: 0.92 }),
    React__namespace.createElement("path", { d: "M2.51865 7.51012C2.51865 7.12352 2.20525 6.81012 1.81865 6.81012C1.43206 6.81012 1.11865 7.12352 1.11865 7.51012L1.11865 7.63667C1.11863 8.44405 1.1186 9.1198 1.1908 9.65678C1.26713 10.2246 1.43555 10.7408 1.85089 11.1562C2.26623 11.5715 2.7825 11.7399 3.35029 11.8163C3.88728 11.8885 4.56302 11.8885 5.3704 11.8884H6.62941C7.43679 11.8885 8.11253 11.8885 8.64952 11.8163C9.21731 11.7399 9.73358 11.5715 10.1489 11.1562C10.5643 10.7408 10.7327 10.2246 10.809 9.65678C10.8812 9.1198 10.8812 8.44407 10.8812 7.6367L10.8812 7.53478C10.8812 7.14818 10.5678 6.83478 10.1812 6.83478C9.79456 6.83478 9.48116 7.14818 9.48116 7.53478V7.58842C9.48116 8.45674 9.47967 9.03756 9.4215 9.47024C9.36603 9.88278 9.27084 10.0544 9.15897 10.1662C9.04711 10.2781 8.87552 10.3733 8.46297 10.4288C8.03029 10.4869 7.44947 10.4884 6.58116 10.4884H5.41865C4.55034 10.4884 3.96952 10.4869 3.53684 10.4288C3.1243 10.3733 2.9527 10.2781 2.84084 10.1662C2.72897 10.0544 2.63378 9.88278 2.57831 9.47024C2.52014 9.03756 2.51865 8.45674 2.51865 7.58842V7.51012Z", fill: props.fillColor, fillOpacity: 0.92 })));

exports.default = Svg12;
//# sourceMappingURL=12.js.map
